// extracted by mini-css-extract-plugin
export var quillEditor = "_ot-1";
export var variable = "_ot-0";